import React from 'react';

const SearchGreyIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
  >
    <g fill="none" fillRule="evenodd">
      <g>
        <g>
          <g>
            <path
              d="M0 0L32 0 32 32 0 32z"
              transform="translate(-164 -264) translate(164 264)"
            />
            <path
              fill="#B4BABF"
              d="M21.242 19.004H20.07l-.417-.401c1.784-2.08 2.705-4.916 2.2-7.93-.699-4.13-4.146-7.426-8.307-7.931C7.259 1.97 1.969 7.257 2.742 13.539c.505 4.158 3.804 7.603 7.935 8.301 3.017.505 5.855-.415 7.935-2.198l.401.416v1.174l6.316 6.311c.61.61 1.605.61 2.214 0 .61-.609.61-1.604 0-2.212l-6.3-6.327zm-8.915 0c-3.7 0-6.687-2.985-6.687-6.683s2.986-6.683 6.687-6.683c3.7 0 6.686 2.985 6.686 6.683s-2.986 6.683-6.686 6.683z"
              transform="translate(-164 -264) translate(164 264)"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default SearchGreyIcon;
